import request from '@/utils/request'

// 0102用户登出
export function logout (data) {
  return request({
    url: '/user/logout',
    method: 'post',
    data
  })
}

// 0104获取用户详情
export function queryUserDetail (data) {
  return request({
    url: '/user/detail',
    method: 'post',
    data
  })
}

// 0105更改用户详情  /user/update
export function updateUserInfo (data) {
  return request({
    url: '/user/update',
    method: 'post',
    data
  })
}

// 0106更改用户密码
export function updatePassword (data) {
  return request({
    url: '/user/password',
    method: 'post',
    data
  })
}

// 0901 获取字典
export function getDict (data) {
  return request({
    url: '/dict',
    method: 'post',
    data
  })
}

// 0701文件上传
export function uploadFile (data) {
  return request({
    url: '/tools/update',
    method: 'post',
    data
  })
}
